import navigateToNextPetsOnboardingPageAction from "@actions/navigateToNextPetsOnboardingPageAction"
import petsOnboardingLoader from "@loaders/petsOnboardingLoader"
import SubscriptionCountPage from "@pages/onboarding/SubscriptionCountPage"
import { Navigate, Outlet } from "react-router-dom"
import PetsAlmostTherePage from "./PetsAlmostTherePage"
import PetsBiggestPainPage from "./PetsBiggestPainPage"
import PetsBlockerPage from "./PetsBlockerPage"
import PetsCommitmentPage from "./PetsCommitmentPage"
import PetsConfidenceLevelPage from "./PetsConfidenceLevelPage"
import PetsCurrentSetupPage from "./PetsCurrentSetupPage"
import PetsDecisionMomentPage from "./PetsDecisionMomentPage"
import PetsDoingGreatPage from "./PetsDoingGreatPage"
import PetsExperimentingPage from "./PetsExperimentingPage"
import PetsFutureOutcomePage from "./PetsFutureOutcomePage"
import PetsMistakeCostPage from "./PetsMistakeCostPage"
import PetsMustTrackPage from "./PetsMustTrackPage"
import PetsPetCountPage from "./PetsPetCountPage"
import PetsShareWithWhoPage from "./PetsShareWithWhoPage"
import PetsStartHerePage from "./PetsStartHerePage"
import PetsSuccessSignalPage from "./PetsSuccessSignalPage"
import PetsTimeSpentPage from "./PetsTimeSpentPage"
import PetsTopPriorityPage from "./PetsTopPriorityPage"
import PetsUpdateFrequencyPage from "./PetsUpdateFrequencyPage"
import PetsWhyPetsProfilePage from "./PetsWhyPetsProfilePage"

const action = navigateToNextPetsOnboardingPageAction

const onboardingPetsRoutes = [
  {
    path: "/onboarding/pets",
    element: <Outlet />,
    loader: petsOnboardingLoader,
    children: [
      {
        element: <Navigate to={`startHere${window.location.search}`} replace />,
        index: true,
      },
      {
        action,
        element: <PetsStartHerePage />,
        path: "startHere",
      },
      {
        action,
        element: <PetsCurrentSetupPage />,
        path: "currentSetup",
      },
      {
        action,
        element: <PetsPetCountPage />,
        path: "petCount",
      },
      {
        action,
        element: <PetsTopPriorityPage />,
        path: "topPriority",
      },
      {
        action,
        element: <PetsWhyPetsProfilePage />,
        path: "whyPetsProfile",
      },
      {
        action,
        element: <PetsBiggestPainPage />,
        path: "biggestPain",
      },
      {
        action,
        element: <PetsUpdateFrequencyPage />,
        path: "updateFrequency",
      },
      {
        action,
        element: <PetsConfidenceLevelPage />,
        path: "confidenceLevel",
      },
      {
        action,
        element: <PetsMustTrackPage />,
        path: "mustTrack",
      },
      {
        action,
        element: <PetsShareWithWhoPage />,
        path: "shareWithWho",
      },
      {
        action,
        element: <PetsDecisionMomentPage />,
        path: "decisionMoment",
      },
      {
        action,
        element: <PetsExperimentingPage />,
        path: "experimenting",
      },
      {
        action,
        element: <PetsDoingGreatPage />,
        path: "doingGreat",
      },
      {
        action,
        element: <PetsTimeSpentPage />,
        path: "timeSpent",
      },
      {
        action,
        element: <PetsMistakeCostPage />,
        path: "mistakeCost",
      },
      {
        action,
        element: <PetsBlockerPage />,
        path: "blocker",
      },
      {
        action,
        element: <PetsFutureOutcomePage />,
        path: "futureOutcome",
      },
      {
        action,
        element: <PetsSuccessSignalPage />,
        path: "successSignal",
      },
      {
        action,
        element: <PetsCommitmentPage />,
        path: "commitment",
      },
      {
        action,
        element: <SubscriptionCountPage />,
        path: "subscriptionCount",
      },
      {
        action,
        element: <PetsAlmostTherePage />,
        path: "almostThere",
      },
    ],
  },
]

export default onboardingPetsRoutes
